/**
 * External dependencies
 */
import { SVG, Path, Rect } from '@wordpress/primitives';

export const reports = (
	<SVG width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<Path
			d="M38.5 16V38C38.5 39.38 37.88 40 36.5 40H10.5V43H36.5C39.54 43 41.5 41.04 41.5 38V16H38.5Z"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Rect
			x="6.5"
			y="4"
			width="28"
			height="32"
			rx="4"
			fill="var(--wpds-color-background-surface-neutral-weak, #F0F0F0)"
		/>
		<Rect
			x="13.5"
			y="21"
			width="3"
			height="7"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Rect
			x="19"
			y="18"
			width="3"
			height="10"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
		<Rect
			x="24.5"
			y="16"
			width="3"
			height="12"
			fill="var(--wpds-color-stroke-surface-neutral-weak, #E0E0E0)"
		/>
	</SVG>
);
